/**
 * Perkecil gambar di browser sebelum diunggah (resize + JPEG).
 *
 * Foto dari kamera HP biasanya 3–8 MB, sedangkan aturan Firebase Storage
 * membatasi ukuran unggahan. Tanpa kompresi, unggahan ditolak dan
 * penyimpanan data ikut gagal.
 */
export const compressImage = (file: File, maxSize = 800, quality = 0.85): Promise<File> =>
    new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
            const width = Math.round(img.width * scale);
            const height = Math.round(img.height * scale);

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                reject(new Error('Canvas tidak didukung'));
                return;
            }
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob(
                blob => {
                    if (!blob) {
                        reject(new Error('Gagal mengompresi gambar'));
                        return;
                    }
                    const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
                    resolve(new File([blob], name, { type: 'image/jpeg' }));
                },
                'image/jpeg',
                quality
            );
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error('File bukan gambar yang valid'));
        };
        img.src = url;
    });
